import { useEffect } from 'react';

import {
    FormControl, InputLabel, OutlinedInput, InputAdornment,
    IconButton, DialogContentText, Stack, TextField, FormHelperText
} from '@mui/material';

import { regex_num } from '../../../constants/regex';

const PasswordForm = ({ data, setData, interfaceData, setInterfaceData }) => {
    const { code_field, code_err, disabled } = interfaceData;

    const { pwd1, pwd2, code, show1, show2, pwd_err } = data;

    useEffect(() => {
        setInterfaceData(e => ({
            ...e, pwd_err: pwd1 !== pwd2 ? true : false
        }));
    }, [pwd1, pwd2]);

    const handleOnChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (['pwd1', 'pwd2'].includes(name)) {
            if (value === '' || value.length <= 64)
                setData(e => ({ ...e, [name]: value }));
        } else if (name === 'code' && code_field) {
            if (value === '' || (value.length <= 6 && regex_num.test(value)))
                setData(e => ({ ...e, code: value }));
            setInterfaceData(e => ({
                ...e, code_err: value.length !== 6 ? true : false
            }));
        }
    };

    return (
        <>
            <DialogContentText>
                Necesita establecer una contraseña para poder continuar con la eliminación de su cuenta.
            </DialogContentText>
            <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel>Contraseña</InputLabel>
                <OutlinedInput
                    type={ show1 ? 'text' : 'password' }
                    style={{ backgroundColor: '#fff' }}
                    name='pwd1'
                    value={ pwd1 }
                    disabled={ code_field }
                    inputProps={{ maxLength: 64 }}
                    onChange={ handleOnChange }
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={ () => setInterfaceData(e => ({ ...e, show1: !e.show1 })) }
                                edge="end"
                            >
                                {
                                    show1 ?
                                        <i className="far fa-eye-slash" style={{ fontSize: '1.3rem' }}></i>
                                    :
                                        <i className="far fa-eye" style={{ fontSize: '1.3rem' }}></i>
                                }
                            </IconButton>
                        </InputAdornment>
                    }
                    label="Contraseña"
                />
            </FormControl>
            <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel>Confirme contraseña</InputLabel>
                <OutlinedInput
                    type={ show2 ? 'text' : 'password' }
                    style={{ backgroundColor: '#fff' }}
                    name='pwd2'
                    value={ pwd2 }
                    disabled={ code_field }
                    inputProps={{ maxLength: 64 }}
                    onChange={ handleOnChange }
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={ () => setInterfaceData(e => ({ ...e, show2: !e.show2 })) }
                                edge="end"
                            >
                                {
                                    show2 ?
                                        <i className="far fa-eye-slash" style={{ fontSize: '1.3rem' }}></i>
                                    :
                                        <i className="far fa-eye" style={{ fontSize: '1.3rem' }}></i>
                                }
                            </IconButton>
                        </InputAdornment>
                    }
                    label="Confirme contraseña"
                />
                {
                    pwd_err &&
                        <FormHelperText error>
                            LAS CONTRASEÑAS NO COINCIDEN
                        </FormHelperText>
                }
            </FormControl>
            <Stack spacing={2} sx={{ mt: 2 }}
                alignItems='flex-start'>
                {
                    code_field &&
                        <TextField
                            label="Código de acceso"
                            type="code"
                            variant="standard"
                            error={ code_err }
                            helperText={ code_err ? "6 dígitos" : "" }
                            inputProps={{ maxLength: 6 }}
                            name="code"
                            value={ code }
                            onChange={ handleOnChange }
                            disabled={ disabled }
                        />
                }
            </Stack>
        </>
    );
};

export default PasswordForm;
